import { getUserInitials, resolveAvatarSrc } from 'utils/avatar';

export function getMeetingCardDisplayAssignment(roleAssignments = [], preferredRole = '') {
  const normalizedPreferredRoles = Array.isArray(preferredRole)
    ? preferredRole
      .map(role => String(role || '').trim())
      .filter(Boolean)
    : [String(preferredRole || '').trim()].filter(Boolean);

  const normalizedAssignments = Array.isArray(roleAssignments) ? roleAssignments : [];

  const matchedAssignment = normalizedPreferredRoles
    .map((preferredRole) => normalizedAssignments.find(
      (assignment) => String(assignment?.role?.name || '').toLowerCase() === preferredRole.toLowerCase()
    ))
    .find(Boolean);

  const activeAssignment = matchedAssignment
    || normalizedAssignments.find(assignment => assignment?.user)
    || normalizedAssignments[0]
    || null;

  const roleLabel = String(activeAssignment?.role?.name || normalizedPreferredRoles[0] || 'Presenter');
  const displayName = activeAssignment?.user?.firstName
    ? `${activeAssignment.user.firstName} ${activeAssignment.user?.lastName || ''}`.trim()
    : 'TBA';
  const avatar = resolveAvatarSrc(activeAssignment?.user?.avatarUrl || activeAssignment?.user?.avatar || '');
  const initials = getUserInitials(activeAssignment?.user, 'T');

  return {
    assignment: activeAssignment,
    roleLabel,
    displayName,
    avatar,
    initials,
  };
}